<template>
    <div class="image-gallery-grid" v-if="content">
        <template v-for="(item, i) in content" :key="i">
            <component
                :is="getElementType(item?.element)"
                v-bind="getLink(item?.element)"
                :target="item?.element?.links?.[0]?.target"
            >
                <custom-image
                    v-if="item?.element?.images?.[0]?.image"
                    :image="item?.element?.images?.[0]?.image"
                    @click="onImageClick($event, item?.element?.clickBehavior)"
                />
            </component>
        </template>
    </div>
    <vue-easy-lightbox
        :visible="visibleRef"
        :imgs="imgsRef"
        :index="indexRef"
        @hide="onHide"
        rotate-disabled
        zoom-disabled
        pinch-disabled
        move-disabled
    />
</template>

<script setup>
import { defineProps } from "vue";
import CustomImage from "@/components/reuseables/customImage.vue";
import VueEasyLightbox, { useEasyLightbox } from 'vue-easy-lightbox'
import { getImagesForLightBox } from '@/mixins/global/globalMethods'

const props = defineProps({
    content: Object
})

function onImageClick(event, clickBehavior) {
    if (clickBehavior === 'lightbox') {
        event.preventDefault()
        visibleRef.value = !visibleRef.value
        indexRef.value = 0
    }
}

function getElementType(element) {
    if (element?.links?.[0]?.link) return 'a'
    else if (element?.links?.[0]?.dataObject?.url) return 'router-link'
    else return 'div'
}

function getLink(element) {
    if (element?.links?.[0]?.link) return { href: element.links[0].link }
    else if (element?.links?.[0]?.dataObject?.url) return { to: `/${element.links[0].dataObject.url}` }
    else return ''
}

const {
    onHide,
    visibleRef,
    indexRef,
    imgsRef,
} = useEasyLightbox({
    imgs: getImagesForLightBox(props.content),
    initIndex: 0,
})
</script>

<style lang="scss" scoped>
.image-gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    gap: 1rem;

    .custom-image {
        break-inside: avoid;
        padding: 1rem;
        border: 1px solid var(--color-border);
    }

    & > div :deep(.image-hover) {
        cursor: default;
    }
}
</style>
